// extracted by mini-css-extract-plugin
export var label = "_rg-0";
export var link = "_rg-1";